import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TripServices from './../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import moment from 'moment';
import ClientService from './../../../../../clientmanagement/services/clientmanagement.service';
import Util from './../../../../../shared/util/util';
import Report from './../../../../../report/services/report.service';
import LRCopy from './../../../../../cargobooking/views/booking/LRCopy';
import AdminSettingsService from './../../../../../adminsettings/services/adminsettings.service';
import pdfMake from "pdfmake/build/pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import Printd from 'printd'
import VueBarcode from 'vue-barcode';
import Multiselect from 'vue-multiselect';

export default {
  name: 'lastmilemgmt',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
    TripServices,
    LRCopy,
    'barcode': VueBarcode,
    Util,
    Multiselect
  },
  props: ['parentOBj','VehicleCapacity'],
  data() {
    return {
      isAllSelected:'',
      isAllAddedSelected:'',
      assignedload:'',
      accordianTab:{1:false, 2:false,3:false},
      expanded:false,
      isLoading:false,
      Vaslist:[],
      Clientlist:[],
      Pincodelist:[],
      ClientName:'',
      AddedAWB:'',
      AWBRADDateRange:'',
      AddedClientName: null,
      Vas:'',
      AWB:'',
      deliveryPincode:'',
      Clientitem:{value:'',text:''},
      Pincodeitem:{value:'',text:''},
      AWBStatusitem:{value:'',text:''},
      Vasitem:{value:'',text:''},
      pageLimit:CONSTANT.PER_PAGE_DATA,
      selectedAWB: [],
      awberr:'',
      subtabdisabledflag: false,
      tableItems: [],
      checkbox:'',
      offset:1,
      offset2: 0,
      pageLimit2: CONSTANT.PER_PAGE_DATA,
      defaultType: "LastMile",
      selectedRemoveAWB: [],
      seletedAWB: [],
      showPrintPage: true,
      bookingData: {},
      removeawberr:'',
      selectedAWBCount: 0,
      pickupFromDate: '',
      pickupToDate: '',
      ClientName: null,
      companyNamelist: [],
      totalCount:0,
      totalCount2:0,
      currentPage: 1,
      currentPage2: 1,
      totalPage: 0,
      totalPage2:0,
      pickupPincode:'',
      expireEBN: [],
      TripId: this.parentOBj? this.parentOBj.tripID : '',
      AWBStatuslist:[
        {id : "delivered",label : 'Delivered'},
        {id : "shipped",label : 'Shipped'}],
      AWBStatus:null,
      AWBStatusFilterList:[
        {id : "shipped",label : 'Shipped'},
        {id : "undelivered",label : 'Shipment Not Delivered'},
      ],
      AWBStatusFilter:null,
      tempPincode:null,
      printMultipleAwbs:[],
      isMultiPrint:true,
	  lastmilescanAWB:'',
	  lastmilescanawbcheck:'',
	  scanAwbArr:[],
	  lastmileallcationscanawb:false,
	  lastmilescanawb:false,
	  multiawbflag:false,
	  isotp:0,
	  otpclients:'',
    clientenablempsallocation:0,
	  multipleawbflag: false,
	  openpickupdeliveryclients:'',
	  isopenpickupdelivery :0,
    }
  },
  computed: {},
  created() {
    this.$root.$refs.tripallocation = this;
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.createdby = userdetail.username;
    this.defaultHubID = userdetail.hubID[0];
    this.hubname = userdetail.currentHubName;
  	this.hubid = userdetail.hubID[0];
  	this.userid = userdetail.userid;
  	this.useremail = userdetail.email;
    // this.defaultHubID = 24;
    this.getCompanyShortName()
    this.getAWBForLastmile()
	this.getOTPClient()
	this.getOpenPickupDeliveryClients()
    if(this.TripId){
      this.getSelectedAWBForTrip()
    }
  },
  methods: {
    select(){
      if(this.isAllSelected){
        this.isAllSelected=0
      }
    },
	isIntegerOnly: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 13) {
          evt.preventDefault();;
        } else {
          return true;
        }
    },
    selectAll() {
      if (this.isAllSelected) {
        this.tableItems.forEach(item => {
          if (item.AlreadyAssign == 1 || item.NumberofMPS == null || item.TotalWeight == null ||  item.disable == 1 || item.disable == 2 || item.disable == 3 || item.disable == 4 || item.disable == 5 || item.appntdateflag == 1) {
            return
          } else {
            if (this.selectedAWB.some(el => el.AWB == item.AWB)) {
              return
            } else {
              this.selectedAWB.push(item)
            }
          }
        })
      }else{
        this.selectedAWB=this.selectedAWB.filter(item=>{
          if(this.tableItems.some(el=>el.AWB==item.AWB)){
            return false
          }else{
            return true
          }
        })
      }
    },
    selectRemove() {
      if (this.isAllAddedSelected) {
        this.isAllAddedSelected = 0
      }
    },
    selectAllAdded() {
      if (this.isAllAddedSelected) {
        this.seletedAWB.forEach(item => {
          if (this.selectedRemoveAWB.some(el => el.AWB == item.AWB)) {
            return
          } else {
            this.selectedRemoveAWB.push(item)
          }
        })
      } else {
        this.selectedRemoveAWB = this.selectedRemoveAWB.filter(item => {
          if (this.seletedAWB.some(el => el.AWB == item.AWB)) {
            return false
          } else {
            return true
          }
        })
      }
    },
    dateFormat(date){
      return moment.utc(date).format("DD-MM-YYYY HH:mm:ss").valueOf();
    },
    dateFormatforApptDate(date){
      return moment.utc(date).format("DD-MM-YYYY").valueOf();
    },

    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },

	async getOTPClient(){
		try {
			this.isLoading = true;
			let inputPayload = {
				key:"otpbaseddelivery"
			};
			let result = await AdminSettingsService.getConfigureClient(inputPayload)
			if(result.data.code == 200){
				this.otpclients = result.data.data;
			}
			this.isLoading = false;	
		} catch (error) {
			this.isLoading = false;
		}
	},
	async getscanAWBForLastmile(){
    try {
			this.isLoading = true;
			this.totalCount = 0;
			this.awberr = ''
			//this.tableItems = []
			let inputPayload = {
			  // hubid: this.defaultHubID,
			  hubid: this.defaultHubID,
			  lastmodifiedby: this.createdby,
			  "offset": this.offset,
			  "limit": this.pageLimit,
			  "type":this.defaultType
      }
      this.lastmilescanAWB = this.lastmilescanAWB.trim()
			if(this.lastmilescanAWB){
				inputPayload.ParentAWB = this.lastmilescanAWB.trim().split();
			}else{
				//this.$alertify.error("Please enter AWB","","error");
				if(this.selectedAWB.length>0){
					this.isAllSelected = 1;
				}
				this.isLoading = false;
				return false;
			}
			let result = await TripServices.GetBookingAllocations(inputPayload)
			if(result.data.code == 200){
			this.tableArr = result.data.data.rows;
			let dataCount = Number(result.data.data.count);
			if(dataCount>0){
				let getAWBObj = await this.getAWBObjForLM(result.data.data.rows)
				if(this.lastmilescanawb){
					if(this.selectedAWB.length<10){
						this.totalCount = this.selectedAWB.length+1;
						let awbValue = getAWBObj[0].AWB
						let checkAWBExistence = this.tableItems.some( ({AWB}) => AWB == awbValue)
						if(!checkAWBExistence){
							this.isAllSelected = 1;	
							this.tableItems = [...this.tableItems,...getAWBObj];
							this.selectAll();	
						}
						else{
							this.$alertify.error("AWB Already added","","error");
						}		
					}
					else{
						this.$alertify.error("Maximum 10 AWB Allowed to Scan","","error");
					}
				}
			}else{
			  this.tableItems = [];
			  this.$alertify.error("No Valid AWB(s) details found","","error");
			}
		  }else{
			this.$alertify.error("No Valid AWB(s) details found","","error");
		  }
			this.lastmilescanAWB = '';
			this.totalPage = 1
			this.isLoading = false;
		  } catch(err){
			console.log(err);
			await this.getscanAWBForLastmile();
			this.isLoading = false;
		  }
	},

    async getAWBForLastmile() {
      try {
        this.isLoading = true;
        this.totalCount = 0;
		this.awberr = ''
        //this.tableItems = []
        let inputPayload = {
          // hubid: this.defaultHubID,
          hubid: this.defaultHubID,
          lastmodifiedby: this.createdby,
          "offset": this.offset,
          "limit": this.pageLimit,
          "type":this.defaultType
        }
        this.AWB = this.AWB ? this.AWB.trim() : this.AWB
		if(this.AWB.trim()){
			let awbnumber = this.AWB.split(/[\n,' ']+/)
			let awbarr = awbnumber.filter(function (n) { return n !== "" });
			if(awbarr.length>10){
			  this.$alertify.error("Maximum 10 AWB Allowed","","error");
			  this.isLoading = false;
			  this.multipleawbflag= true;
			}else{
			  this.multiawbflag = true;
			  inputPayload.ParentAWB = awbarr
			}
			//inputPayload.ParentAWB = this.AWB
		}else{
			//$("#awb").focus();
			$('#AWB').keydown(function(e) {
				if (e.keyCode === 13) {
					$(this).val('').focus();    
					return false;
				}        
			});
		}
		if(this.pickupFromDate && !this.multipleawbflag){
			inputPayload.FromDate = this.pickupFromDate
		}
		if(this.pickupToDate && !this.multipleawbflag){
			inputPayload.ToDate = this.pickupToDate
		}
		if(this.ClientName && !this.multipleawbflag){
			inputPayload.ClientId = this.ClientName.id
		}
		if(this.pickupPincode && !this.multipleawbflag){
			inputPayload.PickupPinCode = this.pickupPincode
		}
		if(this.AWBStatusFilter && !this.multipleawbflag){
			inputPayload.awbstatus = this.AWBStatusFilter
		}
        let result = await TripServices.GetBookingAllocations(inputPayload)
        if(result.data.code == 200){
        this.tableArr = result.data.data.rows;
        this.totalCount = Number(result.data.data.count);
        if(this.totalCount>0){
		  let getAWBObj = await this.getAWBObjForLM(result.data.data.rows)
		  this.tableItems = getAWBObj;
          await this.getExceptionalService()
        }else{
          this.tableItems = [];
		  this.$alertify.error("No Valid AWB(s) details found","","error");
        }
      }else{
		this.multiawbflag = false;
		this.tableItems = [];
		this.$alertify.error("No Valid AWB(s) details found","","error");
	  }
	  this.multipleawbflag = false;
	  this.AWB='';
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        await this.getAWBForLastmile()
        console.log(err);
        this.isLoading = false;
      }
    },
	async getAWBObjForLM(data){
    try {
      let result = data.map((el) => {
        let viewBnBdshipment
        if (el.clientenablempsallocation && el.clientenablempsallocation == 1) {
          if (el.mps.startsWith('BN') || el.mps.startsWith('BD')) {
            viewBnBdshipment = el.mps;
          } else {
            viewBnBdshipment = el.awbnumber
          }
        } else {
          viewBnBdshipment = el.awbnumber
        }
				return {
          'AWB': el.awbnumber, 
          'WayBill':viewBnBdshipment,
					'AWBStatus':el.awbstatus,
					'UserProcess':el.userprocess,
					'ClientName':el.clientname,
					'ClientId': el.clientid,
					'Address':el.address,
					'DeliveryPincode':el.deliverypincode,
					'NumberofMPS': el.numberofmps,
          'NumberofBookedMPS': el.bookedmps,
					'TotalWeight':el.totalwt,
					'TotalPhyWt': (el.ispartialdelivery != undefined || el.ispartialdelivery == 1) ? ((el.totalphywt/el.bookedmps)*el.numberofmps) : el.totalphywt,
					'TotalVolWt':el.totalvolwt,
					'NumberofEWB':el.numberofewb,
					'AWBRADDate':el.raddate == null ? el.awbcreateddate : el.raddate,
					'ValueAddedServices':'Appointment Delivery',
					'State': el.state,
					'City': el.city,
					'EwayBillNo': el.ewaybillnumber,
					'EbnExpiryDate': el.ebnexpirydate,
					'GST': el.gst,
					'BookingMode': el.bookingmode,
					'VTCPaymentMode': el.vtcpaymentmode,
					'DeliveryDatetime': el.deliverydatetime,
					'MallDelivery': el.malldelivery=="Yes"?'Yes':'No',
					'BeneficiaryName': el.beneficiaryname,
					'CollectionAmount': el.collectionamount,
					'AlreadyAssign': el.alreadyassign,
					'TripId': el.tripid?el.tripid:'',
					'TotalInvoice': el.totalinvoice,
					'RouteMode': el.routemode,
					'bookingpickuppincode':el.bookingpickuppincode,
					'bookingdestinationpincode':el.bookingdestinationpincode,
					'clientbusinessaccountid':el.clientbusinessaccountid,
					'dropname':el.dropname,
					'dropconsigneecode':el.dropconsigneecode,
					'disable':(el.disable == 1 || el.disable == 2) ? 0 : el.disable,
					'pickupslotsdate':el.pickupslotsdate,
					'deliveryslotsdate':el.deliveryslotsdate,
					'isrescheduledallowed':el.isrescheduledallowed,
					'appntdateflag':el.appntdateflag,
					'intrastate': el.intrastate,
					'ftcamount':el.ftcamount,
					'activecontractid':el.activecontractid,
					'bookingsource': el.bookingsource,
					'exceptionalservice': " ",
					'ispartialdelivery' : el.ispartialdelivery,
					'phonenumber' : el.phonenumber,
          'pdddate': el.pdddate,
          'isotp': this.otpclients.includes(el.clientbusinessaccountid) ? 1 : 0,
          'isopenpickupdelivery':this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`]? this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`][`${el.routemode}`]?1:0:0,
          'disablereason': el.disablereason,
          'clientenablempsallocation': el.clientenablempsallocation,
          'wopodshipementtag':el.wopodshipementtag == 1 ? 'W/O Pod' : '',
		  'clientmpsitemqty': el.clientmpsitemqty
				  }
			})
			return result;
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}

	},

    async getSelectedAWBForTrip(){
      try {
		this.isLoading = true;
		this.getOTPClient();
		this.getOpenPickupDeliveryClients();
        this.selectedAWBCount = 0
        this.totalCount2=0
        this.seletedAWB = []
		this.removeawberr = ''
        let inputPayload = {
          "offset": this.offset2,
          "limit": this.pageLimit2,
          "TripId": this.TripId,
          "type":this.defaultType
        }
        if(this.AddedAWB){
          inputPayload.awb = this.AddedAWB
        }
        if(this.AWBStatus){
          inputPayload.awbstatus = this.AWBStatus
        }
        if(this.tempPincode){
          inputPayload.pincode = this.tempPincode
        }
        if(this.AddedClientName){
          inputPayload.clientid = this.AddedClientName.id
        }
        if(this.AWBRADDateRange){
          inputPayload.createddate = this.AWBRADDateRange
        }
        let result = await TripServices.GetSelectedAWB(inputPayload)
		this.isLoading = false;
        // this.tableArr = result.data.data.rows;
        this.assignedload = result.data.data.totalphysicalwt;
        this.selectedAWBCount = result.data.data.count;
        this.totalCount2 = Number(result.data.data.count);
        let individualWeight = {'fmweight': result.data.data.fmphysicalwt, 'lmweight': result.data.data.lmphysicalwt};
        if(result.data.data.count>0){
          // let assignedload = 0
          this.seletedAWB = result.data.data.rows.map((el) => {
            let viewBnBdshipment
              if (el.ismpsallocation) {
                if (el.ismpsallocation.startsWith('BN') || el.ismpsallocation.startsWith('BD')) {
                  viewBnBdshipment = el.ismpsallocation;
                } else {
                  viewBnBdshipment = el.awb
                }
              } else {
                viewBnBdshipment = el.awb
              }
            // assignedload += Number(el.totalwt)
            return {
              'AWB': el.awb,
              'WayBill':viewBnBdshipment ,
              'AWBStatus':el.awbstatus,
              'ClientName':el.clientname,
              'Pincode':el.pincode,
              'NumberofMPS':el.numberofmps,
              'NumberofBookedMPS':el.bookingmpscount,
              'TotalWeight':el.totalphysicalwt,
              'AWBRADDate':el.awbcreateddate,
              'pdddate':el.requestedpickupdate,
			  'isotp':this.otpclients.includes(el.clientbusinessaccountid)?1:0,
              'isopenpickupdelivery':this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`]? this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`][`${el.routemode}`]?1:0:0,
			  'clientmpsitemqty': el.clientmpsitemqty
            }
          })
        let getPincodeList = [];
        getPincodeList = result.data.data.rows
        let tempArr= []
        for (var i = 0; i < getPincodeList.length; i++) {
        tempArr.push({
        'id':getPincodeList[i].pincode,
        'label': getPincodeList[i].pincode,
        })
        }
        this.Pincodelist = tempArr.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
        );
          this.$root.$refs.createTripManagement.updateAssignedLoad(this.assignedload,true,individualWeight)

        }else{
          let input = {
            "tripid": this.TripId,
          }
          let status = await TripServices.checkAllocationStatus(input)
          if(status.data.code == 200){
            if (status.data.data.totalphysicalwt) {
              this.$root.$refs.createTripManagement.updateAssignedLoad(status.data.data.totalphysicalwt,false,individualWeight)
            } else {
              this.$root.$refs.createTripManagement.updateAssignedLoad(0,false,individualWeight)
            }
          }
          this.seletedAWB = [];
        }
        if (this.totalCount2 < this.pageLimit2) {
          this.totalPage2 = 1
        } else {
          this.totalPage2 = Math.ceil(this.totalCount2 / this.pageLimit2);
        }
      } catch(err){
        console.log(err);
		this.isLoading = false;
      }
    },

    async onPageChange(page) {
      this.isAllSelected = false;
  this.multiawbflag = false;
      this.selectAll();
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.offset = this.offset + 1
      this.getOTPClient();
      await this.getAWBForLastmile();
      if (this.multiawbflag) {
        this.isAllSelected = true;
        this.selectAll();
      }
    },
    onPageChange2(page) {
      this.isAllAddedSelected = false;
      this.currentPage2 = page;
      this.offset2 = (page - 1) * this.pageLimit2
      this.offset2 = this.offset2
      this.getSelectedAWBForTrip();
    },
    resetFilter(){
	  if(this.lastmilescanawb){
		this.lastmilescanAWB = ''
	  }else{
		this.AWBStatusFilter = null;
		this.AWB = ''
		this.pickupFromDate = ''
		this.pickupToDate = ''
		this.ClientName=null
		this.pickupPincode = ''
		this.multiawbflag = false;
		this.multipleawbflag = false;
		this.isAllSelected = 0;
		this.getOTPClient();
		this.getAWBForLastmile();
		this.selectAll();
		this.getOpenPickupDeliveryClients();
	  }
    },
	LMscanAWB(event){
		this.lastmilescanAWB ='';
		this.tableItems=[];
		this.selectedAWB =[];
		this.isAllSelected= 0;
		if(this.lastmilescanawb){
			this.lastmilescanawb = false;
			this.lastmileallcationscanawb = false;
			this.getAWBForLastmile();
		}	
		else{
			this.totalCount = 0
			this.lastmileallcationscanawb = true;
			this.lastmilescanawb = true;
		}				
	},
    reset(){
        this.AddedAWB = '',
        this.AWBRADDateRange = '',
        this.AWBStatus = null,
        this.AddedClientName = null,
        this.tempPincode = null
        this.onPageChange2(1)
    },

    async addLastMileBooking(){
      try {
        if(this.selectedAWB.length == 0){
          this.awberr = "Please Select Atleast One AWB";
          return false
        }
        this.isLoading = true;
        this.awberr = ''
        let validationPayload = {
          awbarray: [],
          shipmenttype: 'lastmile'
        }
        let dropErrArray = []
        let finalAWBArr = this.selectedAWB.map(obj => {
          let ewbarr = []
          if(obj.GST.length>0){
            obj.GST.forEach(element=>{
              if(element.ewaybillsrnumber){
                ewbarr.push({
                  "EWB":element.ewaybillsrnumber,
                  "PartBupdated":1
                })
              }
            })
          }
          validationPayload.awbarray.push(obj.AWB)
          let temp = {
            "activecontractid":obj.activecontractid,
            'tripid': this.TripId,
            'awbnumner':obj.AWB,
            'awbstatus':'allocsr',
            'clientid':obj.ClientId,
            'clientname':obj.ClientName,
            'address':obj.Address,
            'pickuppincode':obj.DeliveryPincode,
            'numberofmps':obj.NumberofMPS,
            'bookingmpscount':obj.NumberofBookedMPS,
            'totalwt':obj.TotalWeight,
            'totalphywt': obj.TotalPhyWt,
            'bookingphywt': obj.TotalPhyWt,
            'totalvolwt':obj.TotalVolWt,
            'awbcreateddate': obj.AWBRADDate,
            'lastmodifiedby':this.userName,
            'allocationtype': 'lastmile',
            'state': obj.State,
            'city': obj.City,
            'bookingmode': obj.BookingMode,
            'hubid': Number(this.defaultHubID),
            'totalinvoice': Number(obj.TotalInvoice),
            'routemode': obj.RouteMode,
            'bookingpickuppincode':obj.bookingpickuppincode,
            'bookingdestinationpincode':obj.bookingdestinationpincode,
            "clientbusinessaccountid":obj.clientbusinessaccountid,
            'vts': {
              'vtcpaymentmode': obj.VTCPaymentMode? obj.VTCPaymentMode.toString(): '',
              'deliverydatetime': obj.DeliveryDatetime? obj.DeliveryDatetime: '',
              'malldelivery': obj.MallDelivery? obj.MallDelivery: '',
              'beneficiaryname': obj.BeneficiaryName? obj.BeneficiaryName: '',
              'collectionamount': obj.CollectionAmount? obj.CollectionAmount.toString(): ''
            },
            'ewbnumber':ewbarr,
            'intrastate': obj.intrastate,
            'ftcamount':obj.ftcamount,
            'bookingsource':obj.bookingsource,
            'consigneephonenumber':obj.phonenumber,
            'businessunit':obj.businessunit, 
            'requestedpickupdate': obj.pdddate,
            'clientenablempsallocation':obj.clientenablempsallocation,
			'clientmpsitemqty':obj.clientmpsitemqty
          }
          obj.dropname && (temp.dropname = obj.dropname)
          obj.dropconsigneecode && (temp.dropconsigneecode = obj.dropconsigneecode)
          if(!obj.dropname || !obj.dropconsigneecode){
            dropErrArray.push(obj.AWB)
          }
          // if(new Date(obj.EbnExpiryDate).getTime() < new Date().getTime()){
          //   this.expireEBN.push({
          //     awb: obj.AWB,
          //     ewb: obj.EwayBillNo,
          //     reason: 'Expired EWB'
          //   })
          // }
          console.log("TEMP",temp);
          return temp
        })
        // if(this.expireEBN.length > 0){
        //   this.showAWBNotAdded = true
        //   return false
        // }
        if(dropErrArray.length>0){
        let err = dropErrArray.join(" , ")
        this.isLoading=false;
        this.$alert(err, "Please perform complete booking For", "error");
        return false
        }
        let input = {
          AWBArray: finalAWBArr
        }
        let validateAWB = await TripServices.ValidateAllocatedAWb(validationPayload);
        if(validateAWB.data.code == 200){
          this.isLoading = false
          let message  = ''
          validateAWB.data.data.map(el => {
            message += ` ${el.awb},`
          })
          this.$alert(`${message.slice(0,message.length - 1)} Mention AWB already allocated`, "", "error");
        } else {
          let totalAwbWeight = 0
          this.selectedAWB.forEach(item => {
            totalAwbWeight += item.TotalPhyWt
          });
          let assignedload = this.assignedload ? this.assignedload : 0;
          let loadchekdisable = true;
          if ((!loadchekdisable && Number(assignedload) + totalAwbWeight) > this.VehicleCapacity) {
            let overload =  (Number(assignedload) + totalAwbWeight) - this.VehicleCapacity
            this.$alert(`Selected AWBs weighs more than vehicle capacity by ${overload.toFixed(2)} KGS `, "OVERLOAD", "error");
            this.isLoading = false
          } else {
            let result = await TripServices.createLastMileTripAllocation(input);
            this.isLoading = false
            if (result.data.code == 200) {
              let success = [];
              let failure = [];
              result.data.data.forEach(item=>{
                if(item.code==200){
                  success.push(item);
                }else{
                  failure.push(item)
                }
              });
              if(success.length>0){
                this.$alertify.success(result.data.message);
              }
              failure.forEach(item=>{
                this.$alertify.error(item.message);
              })
              this.isAllSelected = false;
              this.selectedAWB = []
              this.offset2 = 0
              this.offset = 1
              this.getAWBForLastmile()
              await this.getSelectedAWBForTrip()
            }
            else if (result.data.code == 412) {
              result.data.message.forEach(el=>{
                this.$alertify.error(`Cannot Add AWB ${el.awb} to the trip : ${el.error} for client ${el.clientname}(${el.clientid})`)
              })
            }
            else if(result.data.code == 900 || result.data.code == 901) {
              // this.$alertify.success(result.data.message);
              this.isAllSelected = false;
              this.selectedAWB = []
              this.offset2 = 0
              this.offset = 1
              this.getAWBForLastmile()
              await this.getSelectedAWBForTrip()
              this.$alert(result.data.message, "", "error");
            }else if(result.data.code == 104){
              this.$alert(result.data.message, "", "error");
              this.$emit('setTripData');
            }
             else {
              this.$alert(result.data.message, "", "error");
            }
			if(this.lastmilescanawb && result.data.code == 200){
				this.tableItems=[];
				this.selectedAWB=[];
				this.totalCount = 0;
			}
          }
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },

    async removeLastMileBooking(){
      try {
        if(this.selectedRemoveAWB.length == 0){
          this.removeawberr = "Please Select Atleast One AWB";
          return false
        }
        this.isLoading = true;
        this.removeawberr = ''
        let finalAWBArr = this.selectedRemoveAWB.map(obj => {
          let temp = {
            'tripid': this.TripId,
            'awbnumner':obj.AWB
          }
          return temp
        })
        let input = {
          RejectAWBArray: finalAWBArr
        }
        let result = await TripServices.RemoveLastMileBooking(input);
        this.isLoading = false
        if(result.data.code == 200){
          this.$alert("AWB Remove Successfully", "", "success");
          this.isAllAddedSelected = false;
          this.selectedRemoveAWB = []
          this.offset2 = 0
          this.offset = 1          
          this.getSelectedAWBForTrip()
		  if(!this.lastmilescanawb){
			this.getAWBForLastmile()
		  }
        }else if(result.data.code == 104){
          this.$alert(result.data.message, "", "error");
          this.$emit('setTripData');
        }
        else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },



selectedAWBStatus(){},
selectedPinCode(){},
selectedClient(){},
selectedVAS(){},
expandAll(){
  this.expanded = true;
  for (var key in this.accordianTab) {
    this.accordianTab[key] = true;
  }
},
collapseAll(){
  this.expanded = false;
  for (var key in this.accordianTab) {
    this.accordianTab[key] = false;
  }
},
toggleCheck(tabid){
  this.expanded = false;
  for (var key in this.accordianTab) {
    if(tabid != key){
      this.accordianTab[key] = false;
    }
  }
},
async getLRdata(awb){
  let payload = {
    'awb':awb
  }
  let data=await TripServices.getLRDetails(payload)
  return data
},
async setMulipleAwbData(){
  this.printMultipleAwbs=[]
  this.isMultiPrint=false
  let printMultipleAwbsLogs = [];
  let inputPayload ={}
  let dt = moment().tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss');
  for(const item of this.selectedRemoveAWB){
    let data = await this.getLRdata(item.AWB)
    if(data.data.code == 200){
      this.printMultipleAwbs.push(data.data.data)
      let awblogs ={
    		AWBNo: data.data.data.awbnumber,
    		loggedinhubid : this.hubid,
    		userid : this.userid,
    		useremail : this.useremail,
    		hubName: this.hubname,
    		createdDate:dt,
    		sourceType: "Web"
    	}
    	printMultipleAwbsLogs.push(awblogs);
    }else{
      this.$alert(item.AWB + " - " + data.data.message,"", "error");
    }
  }
  if(printMultipleAwbsLogs.length >0){
  	inputPayload.awblogs=printMultipleAwbsLogs;
  	let  printawblogsresult= Report.printawblogs(inputPayload);
  }
  this.isMultiPrint=true
},
async printMultipleAwb(){
  if(this.selectedRemoveAWB.length>10){
    this.$alert("Please Select less than 10 AWB for print","", "error");
    return
  }
  this.isLoading=true
  try {
    await this.setMulipleAwbData();
    if (this.printMultipleAwbs.length < 1) {
      this.isLoading = false
      return
    }
    const d = new Printd();
  var buffer = '';
  var cssText = `
       body{
           -webkit-print-color-adjust:exact;
           font-family: Roboto,sans-serif;
           font-size:20%;
       }
       table {
           border-collapse: collapse;
           margin-left:0px !important;
       }
       table, td, th {
         border-style: solid;
         border-width: 1px;
         padding:5px;
       }
       .text-right{
         text-align:right;
       }
       .text-left{
         text-align:left;
       }
       .text-center{
         text-align:center;
       }
       .h3-center-text{
         text-align:center;
       }
       @media print {
       .text-primary th{
         background-color:rgb(226, 216, 216) !important;
         color:black !important;
         font-size:20px !important;
       }
      }
      @media print {
      .pagebreak {
      page-break-after: always;
      }
      }
      `
      this.$nextTick(() => {
        d.print(document.getElementById('printMultiple'), cssText);
      })
    this.isLoading=false
  } catch (error) {
  this.isLoading=false
  }
},
async setdata(AWB){
  this.showPrintPage = false
  let printAwbsLogs = [];
  let inputPayload ={}
  let dt = moment().tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss');
  let data=await this.getLRdata(AWB)
  if(data.data.code == 200){
    this.bookingData = data.data.data
    this.showPrintPage = true
    let awblogs ={
  		AWBNo: data.data.data.awbnumber,
  		loggedinhubid : this.hubid,
  		userid : this.userid,
  		useremail : this.useremail,
  		hubName: this.hubname,
  		createdDate:dt,
  		sourceType: "Web"
  	}
  	printAwbsLogs.push(awblogs);
  	inputPayload.awblogs=printAwbsLogs;
  	let  printawblogsresult= Report.printawblogs(inputPayload);
    return 0
  }else{
    this.$alert(AWB + " - " + data.data.message,"", "error");
    return 1
  }
},
async printAWBPage(AWB) {
  if(await this.setdata(AWB)) return false
  const d = new Printd();
  var buffer = '';
  var cssText = `
       body{
           -webkit-print-color-adjust:exact;
           font-family: Roboto,sans-serif;
           font-size:20%;
       }
       table {
           border-collapse: collapse;
           margin-left:0px !important;
       }
       table, td, th {
         border-style: solid;
         border-width: 1px;
         padding:5px;
       }
       .text-right{
         text-align:right;
       }
       .text-left{
         text-align:left;
       }
       .text-center{
         text-align:center;
       }
       .h3-center-text{
         text-align:center;
       }
       @media print {
       .text-primary th{
         background-color:rgb(226, 216, 216) !important;
         color:black !important;
         font-size:20px !important;
       }
      }
      @media print {
      .pagebreak {
      page-break-after: always;
      }
      }
      `
  d.print(document.getElementById('printAWBData'), cssText);
},
  async getExceptionalService() {
    try {
      let inputPayload ={
        consingneelist : [...new Set(this.tableItems.map((item) => item.dropname))],
        hubid: this.defaultHubID,
        lastmodifiedby: this.createdby
      }
      let result = await TripServices.checkExceptionalService(inputPayload);
      if (result.data.code == 200) {
        this.tableItems.forEach(item => {
          if (result.data.data[item.dropname] <= item.NumberofMPS) {
            item.exceptionalservice = "Delivery Without Scan"
          } else {
            item.exceptionalservice = " "
          }
        })
      } else {

      }
    } catch (error) {
      console.log(error);
    }
  },
  getNotAllocatedShipment() {
    this.getAWBForLastmile()
  },
  async getOpenPickupDeliveryClients(){
	try {
		this.isLoading = true;
		let inputPayload = {
			key:"openpickupdelivery"
		};
		let result = await AdminSettingsService.getOpenPickupDeliveryClientst(inputPayload)
		if(result.data.code == 200){
			this.openpickupdeliveryclients = result.data.data;
		}
		this.isLoading = false;	
	} catch (error) {
		this.isLoading = false;
	}
},

    },
  }


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/AddShipments/lastmilemgmt/lastmilemgmt.component.js